import BossModel from "@/models/BossModel";

export default class Surcharge extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'surcharge';

    /**
     *
     * @type {string}
     */
    static entity = 'surcharges';

    static fields() {
		return {
			id: this.number(null).nullable(),
			code: this.attr(null),
			afas_eid: this.attr(null),
            exact_ledger_number: this.number(null).nullable(),
			name: this.attr(null),
			description: this.attr(null),
			is_active: this.boolean(null),
            is_automated: this.boolean(false),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			web_name: this.attr(null),
			is_discount: this.boolean(null),
			is_customer_visible: this.boolean(null),
            is_customer_visible_changeable:this.boolean(true),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll(){
        return this.api()
            .limit(0)
            .where('is_active',true)
            .get(true);
    }

    /**
     *
     * @param id
     * @param proposalId
     * @param quantity
     * @returns {Promise<AxiosResponse<T>>}
     */
    static loadPrice(id, proposalId, quantity = null) {
        return this.api()
            .action(id + '/calculate/' + proposalId)
            .where('customCount', quantity)
            .getSingle(false);
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }
}
